import { getBrand, getBrandFont, getBrandFavicon } from './brandDomainUtils';
import WelcomePageVianova from '../welcome/components/WelcomePageVianova.web';
import WelcomePageUC from '../welcome/components/WelcomePageUC.web';
import BlankPage from '../welcome/components/BlankPage.web';
export function getBrandCapitalized(url = window.location.href) {
    const brand = getBrand(url);
    return brand.charAt(0).toUpperCase() + brand.slice(1);
}
export function getServiceName(url = window.location.href) {
    return BRAND_CONFIGS[getBrand(url)].name;
}
export const BRAND_CONFIGS = {
    vianova: {
        name: 'Vianova Meeting',
        component: WelcomePageVianova
    },
    kalliope: {
        name: 'Kalliope Meeting',
        component: WelcomePageUC
    },
    xstream: {
        name: 'Hermes Meeting',
        component: WelcomePageUC
    },
    vivavox: {
        name: 'VivaVox Meeting',
        component: WelcomePageUC
    },
    unica: {
        name: 'JoinMeet',
        component: WelcomePageUC
    },
    timenet: {
        name: 'Losiria Meeting',
        component: WelcomePageUC
    },
    '': {
        name: 'Default Meeting',
        component: BlankPage
    }
};
export function applyBranding() {
    const brand = getBrand();
    const config = BRAND_CONFIGS[brand];
    const font = getBrandFont();
    const favicon = getBrandFavicon();
    if (!config)
        return;
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
        link.setAttribute('href', favicon);
    }
    document.body.style.fontFamily = font;
    // Se interfaceConfig esiste globalmente
    if (typeof interfaceConfig !== 'undefined') {
        interfaceConfig.APP_NAME = config.name;
    }
}
/**
 * Restituisce il prefisso "[brand]" dello username per Prosody, per tutti i brand (vianova compresa):
 * il Server_Node sceglie il webservice del brand dal prefisso e il webservice lo toglie.
 * Solo le app mobili possono ancora omettere il prefisso, per retrocompatibilita'.
 */
export function getBrandForLogin(url = window.location.href) {
    const brand = getBrand(url);
    return brand ? `[${brand}]` : '';
}
export { getBrand, getBrandColor, getBrandFont, getBrandFavicon, getBrandPasswordRecoveryPath, getBrandSupportUrl } from './brandDomainUtils';
